import React, { MouseEventHandler, ReactNode } from 'react';

import { cn } from '../../helpers/classBuilders';

export interface DropdownItemProps {
  group?: string;
  children?: ReactNode;
  eventKey?: string;
  onClick: (eventKey: string) => void;
  className: string;
  icon?: ReactNode;
  classBuilder: any;
}

const DropdownItem: React.FC<DropdownItemProps> = ({
  children,
  eventKey,
  onClick,
  className,
  icon,
  classBuilder,
}) => {
  const c = classBuilder;

  const handleButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
    onClick(eventKey);
  };

  return (
    <li role="presentation" className={className}>
      <button
        className={cn(
          c('__dropdown__button'),
          'focus-visible:focus-ring-inset',
        )}
        onClick={handleButtonClick}
        role="menuitem"
      >
        {children}
        {icon}
      </button>
    </li>
  );
};

export default DropdownItem;
